(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('SellerActivitiesController', SellerActivitiesController);

    function SellerActivitiesController($uibModal, $stateParams, Principal, SellerActivityService,
                                        sellerActivityConstants, MODAL_CONTENT_TYPES) {
        var vm = this;
        var activityStatus = sellerActivityConstants.ACTIVITY_STATUS;

        vm.currentPage = 1;
        vm.numPerPage = 10;
        vm.maxSize = 5;

        vm.startRegistry = 1;
        vm.endRegistry = vm.numPerPage;

        vm.paginationOptions = {
            page: vm.currentPage - 1,
            size: vm.numPerPage,
            sort: null
        };

        vm.account = undefined;
        vm.userProfile = undefined;

        vm.loading = false;

        vm.sellerActivities = [];

        vm.totalSellerActivities = vm.sellerActivities.length;

        vm.filter = {
            customerName: ''
        };

        vm.campaign = {};

        vm.searchActivitiesByCustomer = function() {
            vm.currentPage = 1;

            var begin = ((vm.currentPage - 1) * vm.numPerPage),
                end = begin + vm.numPerPage;

            vm.paginationOptions.page = vm.currentPage - 1;

            getSellerActivities(vm.paginationOptions, vm.filter);

            vm.startRegistry = begin + 1;
            vm.endRegistry = end;
        };

        vm.changePage = function () {
            var begin = ((vm.currentPage - 1) * vm.numPerPage),
                end = begin + vm.numPerPage;

            vm.paginationOptions.page = vm.currentPage - 1;

            getSellerActivities(vm.paginationOptions, vm.filter);
            vm.startRegistry = begin + 1;
            vm.endRegistry = end;
        };

        vm.formatDate = formatDate;

        init();

        function init() {
            Principal.identity().then(function (account) {
                if (account) {
                    vm.account = angular.copy(account);
                    vm.userProfile = vm.account.userProfiles[0];
                }
            });
            getSellerActivities(vm.paginationOptions, vm.filter);
        }

        function getSellerActivities (pagination, filter) {
            vm.loading = true;

            var params = filter || {};
            params.campaignId = $stateParams.campaignId;

            SellerActivityService.findByCampaignId(pagination, params).then(function (response) {
                vm.sellerActivities = response.data.activities;
                vm.totalSellerActivities = response.data.total;

                if (response.data.activities && response.data.activities.length > 0) {
                    var unpaginatedTotal = 0;
                    var unpaginatedFinished = 0;
                    if (response.data.statusCount && Array.isArray(response.data.statusCount)) {
                        unpaginatedTotal = response.data.statusCount.reduce(function (sum, statusTotal) {
                            return sum + statusTotal.total;
                        }, 0);
                        unpaginatedFinished = response.data.statusCount
                            .filter(function (statusTotal) {
                                return statusTotal.status === activityStatus.DONE || statusTotal.status === activityStatus.CANCELLED;
                            })
                            .reduce(function (sum, statusTotal) {
                                return sum + statusTotal.total;
                            }, 0);
                    }
                    vm.campaign = {
                        id: response.data.activities[0].campaign.id,
                        name: response.data.activities[0].campaign.name,
                        description: response.data.activities[0].campaign.description,
                        content: response.data.activities[0].campaign.content,
                        status: response.data.activities[0].campaign.status,
                        total: unpaginatedTotal,
                        done: unpaginatedFinished

                    };
                }
                vm.loading = false;
            });
            return vm.sellerActivities;
        }

        function updateActivityStatus(activity , newStatus) {
            var index = vm.sellerActivities.findIndex(function (item) {
                return item.id === activity.id;
            });
            if (index === -1) return;
            SellerActivityService.updateStatus(activity.id, { status: newStatus }).then(function (result) {
                activity.status = newStatus;
                vm.sellerActivities.splice(index, 1, activity);
                var unpaginatedTotal =
                    result.data.campaignSeller.campaign.activityStatusCount.reduce(function (sum, statusTotal) {
                        return sum + statusTotal.total;
                    }, 0);
                var unpaginatedFinished = result.data.campaignSeller.campaign.activityStatusCount
                    .filter(function (statusTotal)
                {
                        return statusTotal.status === activityStatus.DONE || statusTotal.status === activityStatus.CANCELLED
                    })
                    .reduce(function (sum, statusTotal) {
                        return sum + statusTotal.total;
                    }, 0);
                vm.campaign.total = unpaginatedTotal;
                vm.campaign.done = unpaginatedFinished;
            });
        }

        vm.startActivity = function (activity) {

            var index = vm.sellerActivities.findIndex(function (item) {
                return item.id === activity.id;
            });

            if (index === -1) return;

            if (activity.status === activityStatus.PENDING) {
                updateActivityStatus(activity, activityStatus.DOING);
            }

            return $uibModal.open({
                templateUrl: "app/admin/seller-campaigns/send-message-modal/send-message-modal.html",
                windowClass: 'modal-side-menu',
                size: 'md',
                controller: "SendMessageModalController",
                controllerAs: "vm",
                backdrop: 'static',
                resolve: {
                    campaign: function () {
                        return vm.campaign;
                    },
                    activity: function () {
                        return activity;
                    }
                },
            }).result.then(function (result) {
                if (angular.isDefined(result)) {
                    if (result) {
                        updateActivityStatus(activity, activityStatus.DONE);
                    }
                }
            });
        };

        vm.openSideMenu = function (customer) {
            return $uibModal.open({
                templateUrl: 'app/components/modal/side-modal/side-modal.html',
                controller: 'SideModalController',
                controllerAs: 'vm',
                windowClass: 'side-modal',
                backdrop: 'static',
                resolve: {
                    content: function () {
                        return {
                            customer: customer,
                            type: MODAL_CONTENT_TYPES.CUSTOMER
                        }
                    }
                }
            }).result.then(function (result) {
                getSellerActivities(vm.paginationOptions, vm.filter);
            });
        };

        vm.addressFormat = function (customer) {
            var zipcode = customer.zipCode;
            var address = customer.address;
            var state = customer.state;
            var city = customer.city;
            var addressNumber = customer.addressNumber;

            if (!zipcode && !address && !state && !city && !addressNumber) {
                return null;
            }

            return (
                (address ? address + (addressNumber ? ", " : " ") : "") +
                (addressNumber ? addressNumber + (city ? " - " : " ") : "") +
                (city ? city + (state ? ", " : " ") : "") +
                (state ? state + (zipcode ? ", " : " ") : "") +
                (zipcode ? zipcode : "")
            );
        };

    }
})();
